import { useNavigate } from 'react-router-dom'

import {
	IHighlightsFolder,
	IImportSharedHighlightsResponse
} from '@/types/highlight.interface'

interface IUseSharedHighlightsImport {
	taskId?: string
	selectedFolderIds: number[]
	importSharedHighlights: (params: {
		highlightIds?: number[]
	}) => Promise<IImportSharedHighlightsResponse>
}
export const useSharedHighlightsImport = ({
	taskId,
	selectedFolderIds,
	importSharedHighlights
}: IUseSharedHighlightsImport) => {
	const navigate = useNavigate()

	const redirectAfterImport = (folders: IHighlightsFolder[]) => {
		const importedTaskId = folders[0]?.task_id || taskId

		if (importedTaskId) {
			navigate(`/live/${importedTaskId}`)
		}
	}

	const importAllFolders = async () => {
		try {
			const response = await importSharedHighlights({})

			redirectAfterImport(response.highlights)
		} catch (error) {
			console.log(error)
		}
	}

	const importSelectedFolders = async () => {
		if (!selectedFolderIds.length) return

		try {
			const response = await importSharedHighlights({
				highlightIds: selectedFolderIds
			})

			redirectAfterImport(response.highlights)
		} catch (error) {
			console.log(error)
		}
	}

	return {
		importAllFolders,
		importSelectedFolders
	}
}
